import amplitude from 'amplitude-js';
import * as ZoominfoAnalytic from '@zoominfo/zoominfo-analytic';
import { REACT_APP_AMPLITUDE_API_KEY } from '../config';

const PLATFORM = {
  LEGACY: 'Legacy',
  SALES_OS: 'Sales OS',
  MARKETING_OS: 'Marketing OS',
};

/**
 * Identify the platform name from the URL
 * @returns {String} Platform name
 */
const getPlatform = () => {
  const path = window.location.href.split('/');
  if (path && path[2] && path[2].includes('insent.ai')) {
    return PLATFORM.LEGACY;
  }
  return path && path[3] && path[3] === 'mos' ? PLATFORM.MARKETING_OS : PLATFORM.SALES_OS;
};

const DEFAULT_PROPERTIES = {
  application: 'ZIChat',
  PDM_PLATFORM: getPlatform(),
  PDM_APPLICATION: 'Web',
  PDM_APPLICATION_ATTRIBUTE: '',
  PDM_PRODUCT_CATEGORY: 'Chat',
};

export const EVENTS = {
  OPENED_TOOL: 'OpenedTool',
  CONVERSATION_CREATED: 'ConversationCreated',
  AUDIENCE_UPDATED: 'AudienceUpdated',
  CONVERSATION_UPDATED: 'ConversationUpdated',
  SHARED_PATH_UPDATED: 'SharedPathUpdated',
  PAGE_ACTIONS: 'PageActions',
};

/**
 * Initializes default instance of Amplitude client
 */
export const initAmplitude = () => {
  try {
    amplitude.getInstance().init(REACT_APP_AMPLITUDE_API_KEY);
  } catch (err) {
    console.log('Amplitude Initialization FAILED:' + err);
  }
};

/**
 * Log the events into Amplitude
 * @param {String} eventName - the name of the event type
 * @param {Object} eventProperties - additional event properties
 */
export const logAmplitudeEvent = (eventName, eventProperties) => {
  try {
    const event = ZoominfoAnalytic.events.make(eventName, {
      PDM_PRODUCT_TYPE: window?.appDetails?.subscription?.name,
      source: window?.location?.pathname + window?.location?.search,
      ...DEFAULT_PROPERTIES,
      ...eventProperties,
    });
    amplitude.getInstance().logEvent(event.name, event.properties);
  } catch (err) {
    console.log('Amplitude Event tracking FAILED:' + err);
  }
};

/**
 * Set the user details in Amplitude
 * @param {String} userId - the user ID of the logged in user
 * @param {String} emailId - the email ID of the logged in user
 */
export const updateUserProperties = properties => {
  try {
    amplitude.getInstance().setUserProperties({
      ...properties,
    });
  } catch (err) {
    console.log('Amplitude User Update FAILED:' + err);
  }
};

/**
 * Set the user user ID in Amplitude
 * @param {String} userId - the user ID of the logged in user
 */
export const updateUserId = userId => {
  try {
    amplitude.getInstance().setUserId(userId);
  } catch (err) {
    console.log('Amplitude User Update FAILED:' + err);
  }
};
